import React from "react";
import { Link } from "react-router-dom";
import { usePageSeo } from "../../shared/seo";

const SUPPORT_PHONE = "+91 8086871402";
const SUPPORT_EMAIL = "fugusfresh@gmail.com";

const faqs = [
  {
    question: "How do I place an order?",
    answer:
      "Browse our products, add the items you want to your cart, then proceed to checkout. Select your delivery address, choose a delivery slot, and confirm your payment to place the order.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept online payments via cards, UPI, and popular wallets, as well as Cash on Delivery where available. All transactions are processed through a secure payment gateway.",
  },
  // {
  //   question: "Can I cancel or modify my order?",
  //   answer:
  //     "You may cancel an order before it is processed for delivery. Once the order has been dispatched, cancellation may no longer be possible. Please contact support as early as possible.",
  // },
  // {
  //   question: "How long does delivery take?",
  //   answer:
  //     "Delivery times depend on your selected slot and location. We aim to deliver within your chosen two-hour window. You can track your order status from your account.",
  // },
  // {
  //   question: "What should I do if I receive a damaged or incorrect item?",
  //   answer:
  //     "Please inspect your order upon delivery and report any damaged, poor quality, or incorrect items to us within 24 hours. We will arrange a replacement or refund as applicable.",
  // },
  // {
  //   question: "How are refunds processed?",
  //   answer:
  //     "Refunds are processed to your original payment method. Depending on your bank or payment provider, it may take a few business days for the amount to appear in your account.",
  // },
  {
    question: "How do I update my delivery address?",
    answer:
      "You can add or update your saved addresses anytime from the Address Book section of your account before placing an order.",
  },
];

const Support = () => {
  usePageSeo("support");

  return (
    <section className="section py-40 py-sm-60">
      <div className="container container-lg">
        <div className="text-center mb-32 mb-sm-40">
          <h2 className="fw-bold text-main-700 mb-8">Customer Support</h2>
          <p className="text-neutral-600 mb-0">
            We're here to help. Reach out to us for any questions or assistance.
          </p>
        </div>

        <div className="mx-auto" style={{ maxWidth: "980px" }}>
          <div
            className="rounded-12 bg-white border border-main-100 p-24 p-sm-32 mb-32"
            style={{ boxShadow: "0 2px 8px rgba(26, 107, 48, 0.05)" }}
          >
            <div className="row g-3 g-sm-4">
              <div className="col-12 col-md-6">
                <div className="d-flex align-items-center gap-12 p-16 rounded-10 bg-main-50">
                  <span className="d-flex text-28 text-main-600">
                    <i className="ph-fill ph-phone-call" />
                  </span>
                  <div>
                    <p className="mb-0 text-neutral-600 text-sm">
                      Customer Support Phone
                    </p>
                    <a
                      href={`tel:${SUPPORT_PHONE.replace(/[^+\d]/g, "")}`}
                      className="fw-bold text-main-700 text-decoration-none hover-text-main-600"
                    >
                      {SUPPORT_PHONE}
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="d-flex align-items-center gap-12 p-16 rounded-10 bg-main-50">
                  <span className="d-flex text-28 text-main-600">
                    <i className="ph-fill ph-envelope-simple" />
                  </span>
                  <div>
                    <p className="mb-0 text-neutral-600 text-sm">
                      Support Email
                    </p>
                    <a
                      href={`mailto:${SUPPORT_EMAIL}`}
                      className="fw-bold text-main-700 text-decoration-none hover-text-main-600"
                    >
                      {SUPPORT_EMAIL}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="rounded-12 bg-white border border-main-100 p-24 p-sm-32"
            style={{ boxShadow: "0 2px 8px rgba(26, 107, 48, 0.05)" }}
          >
            <h5 className="fw-bold text-main-700 mb-8">🐟 How to Place an Order</h5>
            <ul className="mb-24 ps-4 text-neutral-700" style={{ listStyle: "none" }}>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                Browse the fresh fish and seafood available in our collections.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                Add your desired items and quantities to your cart.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                Proceed to checkout and select your delivery address and slot.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                Choose your payment method and confirm the order.
              </li>
            </ul>

            <h5 className="fw-bold text-main-700 mb-8">💳 Payment-Related Help</h5>
            <ul className="mb-24 ps-4 text-neutral-700" style={{ listStyle: "none" }}>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                We accept online payments via cards, UPI, and wallets, plus Cash
                on Delivery where available.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                All payments are processed through a secure gateway.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                If a payment fails, please check with your bank or retry with a
                different method.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                For any payment issues, contact us and we'll be happy to help.
              </li>
            </ul>

            {/* <h5 className="fw-bold text-main-700 mb-8">📦 Order & Cancellation Information</h5>
            <ul className="mb-24 ps-4 text-neutral-700" style={{ listStyle: "none" }}>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                You can track your order status from the My Orders section of
                your account.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                Orders can be cancelled before they are processed for delivery.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                Once dispatched, cancellation may not be possible.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                Please inspect your order upon delivery and report issues within
                24 hours.
              </li>
            </ul> */}

            {/* <h5 className="fw-bold text-main-700 mb-8">🔄 Refund Information</h5>
            <ul className="mb-24 ps-4 text-neutral-700" style={{ listStyle: "none" }}>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                For damaged, poor-quality, or incorrect items, we arrange a
                replacement or refund as applicable.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                Refunds are processed to your original payment method.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                Your refund may take a few business days to reflect, depending on
                your bank.
              </li>
            </ul> */}

            <h5 className="fw-bold text-main-700 mb-16">❓ Frequently Asked Questions</h5>
            <div className="d-flex flex-column gap-12">
              {faqs.map((faq, index) => (
                <div
                  key={faq.question}
                  className="rounded-10 border border-main-100 p-16 p-sm-20"
                >
                  <p className="fw-bold text-main-700 mb-8">
                    {index + 1}. {faq.question}
                  </p>
                  <p className="text-neutral-700 mb-0">{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>

          {/* <div className="text-center mt-32">
            <p className="text-neutral-600 mb-0">
              Still need help?{" "}
              <Link
                to="/contact"
                className="text-main-600 fw-bold text-decoration-none hover-text-main-700"
              >
                Contact Us
              </Link>
            </p>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Support;
